<template>
    <div style="padding: 20px;">
        <div id="login-container" class="col-xs-12 col-md-5 col-sm-12">
            <h2 style="text-align:center; margin-bottom: 35px;">Confirm email</h2>
            <p>Almost done...</p>
            <p>We have sent an email with a confirmation link to your email address. Please allow 5-10 minutes for this message to arrive.</p>
            <b-button @click="resendModalOpen()" type="is-primary" style="width:100%; margin-top: 25px;">Resend email</b-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {loginUser} from '../../logic/account'
    import ModalResendEmail from '../../components/ModalResendEmail'

    export default {
        data(){
            return {

            }
        },
        components: {},
        methods: {
            resendModalOpen: function(){
                let _this = this;
                _this.$modal.open({
                    parent: this,
                    component: ModalResendEmail,
                    hasModalCard: true,
                    props: {},
                    events: {}
                })
            },
            showSuccessMsg: function(message, msg_type){
                this.$toast.open({message: message, type: msg_type})
            },           
        }
    }
</script>


<style scoped>
    #login-container >>> label,
    #register-container >>> label{
        text-align: left;
        padding: 0px;
        font-weight: 400;
    }

    #login-container >>> .field,
    #register-container >>> .field{
        margin-bottom: 20px;
    }

    #login-container{
        display: block;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
        text-align: left;
    }

    #login-container h2{margin:20px;}
    #login-container .center{
        text-align:center;
        margin:20px;
    }

    #register-container{
        display: none;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
    }

    #register-container h2{margin:20px;}
    #register-container .center{
        text-align:center;
        margin:20px;
    }

    #header{display: none;}
</style>
